import React, { useState, useEffect } from "react";
import { Link, useParams } from "react-router-dom";
import { gsap } from "gsap";
import axios from "axios";
import configData from "../config.json";

function ResetPasswordConfirm(props) {
  const { uid, token } = useParams();
  const [newPassword, setNewPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [success, setSuccess] = useState(false);
  const [error, setError] = useState(null);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    gsap.to('#core', { backgroundColor: '#eee', duration: 0.3 });
    props.menuColor('none');
    props.accentColor('#FFFFFF');
    props.logoColor('fillBlack');
    document.title = "Set New Password | " + configData.BASE_TITLE;
    document.querySelector('meta[name="description"]').setAttribute("content", "");
    document.documentElement.scrollTop = 0;
  }, []);

  function handleSubmit() {
    if (!newPassword || !confirmPassword) return;

    if (newPassword !== confirmPassword) {
      setError("Passwords do not match.");
      return;
    }

    setLoading(true);
    setError(null);

    axios({
      method: 'post',
      baseURL: configData.API_URL,
      url: '/auth/users/reset_password_confirm/',
      data: {
        uid: uid,
        token: token,
        new_password: newPassword,
      }
    })
      .then(() => {
        setSuccess(true);
        setLoading(false);
      })
      .catch((err) => {
        setLoading(false);
        if (err.response && err.response.data) {
          const data = err.response.data;
          if (data.new_password) {
            setError(data.new_password.join(" "));
          } else if (data.token) {
            setError("This reset link has expired or is invalid. Please request a new one.");
          } else if (data.uid) {
            setError("This reset link is invalid. Please request a new one.");
          } else {
            setError("Something went wrong. Please try again.");
          }
        } else {
          setError("Something went wrong. Please try again.");
        }
      });
  }

  function handleKeyUp(e) {
    if (e.key === "Enter") {
      handleSubmit();
    }
  }

  if (success) {
    return (
      <section className="main pageItem-enter-active" id="loginFormPage">
        <div className="loginForm">
          <h1>Password Reset</h1>
          <p className="resetMessage">
            Your password has been updated successfully.
          </p>
          <div className="formField">
            <Link to="/signin/" className="btn1 submitBtn resetLink">Sign In</Link>
          </div>
        </div>
      </section>
    );
  }

  return (
    <section className="main pageItem-enter-active" id="loginFormPage" onKeyUp={handleKeyUp}>
      <div className="loginForm">
        <h1>Set New Password</h1>
        <div className="formField">
          <input
            type="password"
            name="new_password"
            id="new_password"
            required
            placeholder="new password"
            value={newPassword}
            onChange={(e) => setNewPassword(e.target.value)}
          />
        </div>
        <div className="formField">
          <input
            type="password"
            name="confirm_password"
            id="confirm_password"
            required
            placeholder="confirm password"
            value={confirmPassword}
            onChange={(e) => setConfirmPassword(e.target.value)}
          />
        </div>
        {error && <p className="resetError">{error}</p>}
        <div className="formField">
          <input
            type="submit"
            className="btn1 submitBtn"
            value={loading ? "Saving..." : "Set Password"}
            onClick={handleSubmit}
            disabled={loading}
          />
        </div>
      </div>
    </section>
  );
}

export default ResetPasswordConfirm;
